<template>
  <div v-if="quoteType && articles && categories">
    <h1>Quote type</h1>
    <v-btn :to="{name:'quoteTypes'}">
      <v-icon>chevron_left</v-icon>Quote types
    </v-btn>
    <v-alert
      :value="true"
      type="info"
    >Enter information for this quote type. Choose an article on the client website for this quote to appear there.</v-alert>
    <v-text-field label="Id" v-model="quoteType.id" :readonly="true" outline />
    <v-text-field label="Name" v-model="quoteType.name" outline />
    <v-autocomplete
      label="Article"
      v-model="quoteType.articleid"
      :items="articles"
      item-value="id"
      item-text="pageName"
      outline
    />
    <v-text-field label="Abbreviation" v-model="quoteType.abbreviation" outline />
    <v-text-field label="Icon awesome" v-model="quoteType.iconawesome" outline />
    <v-text-field label="Oldid" v-model="quoteType.oldid" outline />
    <v-checkbox label="Inactive" v-model="quoteType.inactive" outline />
    <h3>Categories</h3>
    <v-checkbox
      v-for="category in categories"
      :key="category.id"
      :value="category.id"
      :label="category.shortname"
      v-model="selectedCategories"
    />
    <v-btn @click="saveQuoteType">
      <v-icon>save</v-icon>Save
    </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "QuoteType",
  metaInfo() {
    return {
      title: "Quote type",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      quoteType: null,
      quoteTypeCategories: null,
      categories: null,
      articles: null,
      selectedCategories: []
    };
  },
  methods: {
    fetchQuoteType() {
      nbmlaw
        .get(`/cors/admin/sales/quoteTypes/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.quoteType = response.data;
        })
        .catch(() => {});
    },
    fetchQuoteTypeCategories() {
      nbmlaw
        .get(`/cors/admin/sales/quoteTypes/${this.$route.params.id}/categories`)
        .then(response => {
          // console.log(response.data);
          this.quoteTypeCategories = response.data;
        })
        .catch(() => {});
    },
    fetchCategories() {
      nbmlaw
        .get(`/cors/admin/file/categories`)
        .then(response => {
          // console.log(response.data);
          this.categories = response.data;
        })
        .catch(() => {
          // console.log(error)
        });
    },
    fetchArticles() {
      nbmlaw
        .get(`/cors/admin/extras/articles`)
        .then(response => {
          // console.log(response.data);
          this.articles = response.data;
        })
        .catch(() => {
          // console.log(error)
        });
    },
    saveQuoteType() {
      if (this.$route.params.id) {
        this.updateQuoteType();
      } else {
        this.createQuoteType();
      }
    },
    createQuoteType() {
      nbmlaw
        .post(`/cors/admin/sales/quoteTypes`, this.quoteType, {
          params: { selectedCategories: this.selectedCategories.join(".") }
        })
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "quoteTypes" });
        })
        .catch(() => {});
    },
    updateQuoteType() {
      nbmlaw
        .put(
          `/cors/admin/sales/quoteTypes/${this.$route.params.id}`,
          this.quoteType,
          {
            params: { selectedCategories: this.selectedCategories.join(".") }
          }
        )
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "quoteTypes" });
        })
        .catch(() => {});
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchQuoteType();
          this.fetchQuoteTypeCategories();
        } else {
          this.quoteType = {};
        }
      }
    },
    quoteTypeCategories: {
      handler() {
        if (this.quoteTypeCategories) {
          this.selectedCategories = this.quoteTypeCategories.map(c => c.id);
        } else {
          this.selectedCategories = [];
        }
      }
    }
  },
  created() {
    this.fetchArticles();
    this.fetchCategories();
  }
};
</script>